import { Blocks } from "@/types";

export type StructureBlocksState = {
    blocks: Blocks;
};
export const structure_blocks_state: StructureBlocksState = {
    blocks: new Map(),
};
